import { gsap } from "gsap";
import LocomotiveScroll from 'locomotive-scroll';
import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { EaselPlugin } from "gsap/EaselPlugin";
// Import Highway
import Highway from '@dogstudio/highway';


gsap.registerPlugin(ScrollTrigger,ScrollToPlugin,EaselPlugin);

// For Live Projects
window.addEventListener('load',function(){
  document.querySelector('body').classList.add("loaded")  
});


const lenis = new Lenis({
	lerp:0.07,
	duration:1.2,

});

lenis.on('scroll', (e) => {
  console.log(e)
})

lenis.on('scroll', ScrollTrigger.update)

gsap.ticker.add((time)=>{
  lenis.raf(time * 1000)
})

gsap.ticker.lagSmoothing(0)



let mm = gsap.matchMedia();

mm.add("(min-width: 800px)", () => {

  // desktop setup code here...

  const dual = gsap.timeline({
  scrollTrigger:{
    scrub:1.2,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-1",
    start:"top top",
    end:"bottom +=100",
  },
});

dual.from(".dual-arcade-container",{scale:1.8,duration:1});
dual.to(".dual-arcade-container",{y:-100,duration:1}, "-=1");

const dual2 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-3",
    start:"top top",
    end:"+=3000",
  },
});


// gsap.to(".dual-clouds", {
//     duration: 1.5,
//     x: 100,
//     repeat: -1,
//     yoyo: true,
//     ease: "sine.inOut"
// });



dual2.from("#dual-sec-3",{opacity:0,duration:2});
dual2.from(".dual-3",{opacity:0, duration:2});
dual2.from(".dual-3-ground",{y:100,duration:2}, "-=1");
dual2.to(".dual-3-bar",{y:100,opacity:0, duration:2},);
dual2.from(".dual-3-blister",{y:100,opacity:0,duration:2});
dual2.to(".dual-3-ground",{y:220,duration:1,opactiy:0},);
dual2.to(".dual-3-blister",{opacity:0},);
dual2.from(".dual-3-fb",{opacity:0,},);
dual2.to(".dual-3-fb",{opacity:0,duration:1},);
dual2.from(".dual-3-ca",{opacity:0,duration:1},);
dual2.to("#dual-sec-3",{opacity:0},);


const dual3 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-4",
    start:"top top",
    end:"+=3000",
  },
});

dual3.from("#dual-sec-4",{opacity:0,duration:2});
dual3.from(".dual-4",{opacity:0, duration:2});
dual3.from(".dual-4-ground",{y:100,duration:2}, "-=1");
dual3.to(".dual-4-bar",{y:100,opacity:0, duration:2},);
dual3.from(".dual-4-blister",{y:100,opacity:0,duration:2});
dual3.to(".dual-4-ground",{y:220,duration:1,opactiy:0},);
dual3.to(".dual-4-blister",{opacity:0},);
dual3.from(".dual-4-fb",{opacity:0},);
dual3.to(".dual-4-fb",{opacity:0, duration:1},);
dual3.from(".dual-4-ca",{opacity:0, duration:1},);
dual3.to("#dual-sec-4",{opacity:0},);


const dual4 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-5",
    start:"top top",
    end:"+=3000",
  },
});

dual4.from("#dual-sec-5",{opacity:0,duration:2});
dual4.from(".dual-5",{opacity:0, duration:2});
dual4.from(".dual-5-ground",{y:100,duration:2}, "-=1");
dual4.to(".dual-5-bar",{y:100,opacity:0, duration:2},);
dual4.from(".dual-5-blister",{y:100,opacity:0,duration:2});
dual4.to(".dual-5-ground",{y:220,duration:1,opactiy:0},);
dual4.to(".dual-5-blister",{opacity:0},);
dual4.from(".dual-5-fb",{opacity:0},);
dual4.to(".dual-5-fb",{opacity:0, duration:1},);
dual4.from(".dual-5-ca",{opacity:0, duration:1},);
dual4.to(".dual-5-blister",{opacity:0},);

dual4.to("#dual-sec-5",{opacity:0},);

const dual5 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-6",
    start:"top top",
    end:"+=3000",
  },
});

dual5.from("#dual-sec-6",{opacity:0,duration:2});
dual5.from(".dual-6",{opacity:0, duration:2});
dual5.from(".dual-6-ground",{y:100,duration:2}, "-=1");
dual5.to(".dual-6-bar",{y:100,opacity:0, duration:2},);
dual5.from(".dual-6-blister",{y:100,opacity:0,duration:2});
dual5.to(".dual-6-ground",{y:220,duration:1,opactiy:0},);
dual5.to(".dual-6-blister",{opacity:0},);
dual5.from(".dual-6-fb",{opacity:0},);
dual5.to(".dual-6-fb",{opacity:0, duration:1},);
dual5.from(".dual-6-ca",{opacity:0, duration:1},);


const dual7 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-7",
    start:"top top",
    end:"+=3000",
  },
});

dual7.from("#dual-sec-7",{opacity:0,duration:2});
dual7.from(".dual-7",{opacity:0, duration:2});
dual7.from(".dual-7-ground",{y:100,duration:2}, "-=1");
dual7.to(".dual-7-bar",{y:100,opacity:0, duration:2},);
dual7.from(".dual-7-blister",{y:100,opacity:0,duration:2});
dual7.to(".dual-7-ground",{y:220,duration:1,opactiy:0},);
dual7.to(".dual-7-blister",{opacity:0},);

const dual8 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-8",
    start:"top top",
    end:"+=3000",
  },
});

dual8.from("#dual-sec-8",{opacity:0,duration:2});
dual8.from(".dual-8",{opacity:0, duration:2});
dual8.from(".dual-8-ground",{y:100,duration:2}, "-=1");
dual8.to(".dual-8-bar",{y:100,opacity:0, duration:2},);
dual8.from(".dual-8-blister",{y:100,opacity:0,duration:2});
dual8.to(".dual-8-ground",{y:220,duration:1,opactiy:0},);
dual8.to(".dual-8-blister",{opacity:0},);


});

mm.add("(max-width: 799px)", () => {
  // mobile setup code here...


  const dual = gsap.timeline({
  scrollTrigger:{
    scrub:1.2,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-1",
    start:"top top",
    end:"200%",
  },
});

dual.from(".dual-arcade-container",{scale:2,duration:1});
dual.to(".dual-arcade-container",{y:-100,duration:1}, "-=1");

const dual2 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-3",
    start:"top top",
    end:"+=3000",
  },
});

// gsap.to(".dual-clouds", {
//     duration: 1.5,
//     x: 100,
//     repeat: -1,
//     yoyo: true,
//     ease: "sine.inOut"
// });



dual2.from("#dual-sec-3",{opacity:0,duration:2});
dual2.from(".dual-3",{opacity:0, duration:2});
dual2.from(".dual-3-ground",{y:100,duration:2}, "-=1");
dual2.to(".dual-3-bar",{y:100,opacity:0, duration:2},);
dual2.from(".dual-3-blister",{y:100,opacity:0,duration:2});
dual2.to(".dual-3-ground",{y:220,duration:1,opactiy:0},);
dual2.to(".dual-3-blister",{opacity:0},);
dual2.from(".dual-3-fb",{opacity:0,},);
dual2.to(".dual-3-fb",{opacity:0,duration:1},);
dual2.from(".dual-3-ca",{opacity:0,duration:1},);
dual2.to("#dual-sec-3",{opacity:0},);


const dual3 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-4",
    start:"top top",
    end:"+=3000",
  },
});

dual3.from("#dual-sec-4",{opacity:0,duration:2});
dual3.from(".dual-4",{opacity:0, duration:2});
dual3.from(".dual-4-ground",{y:100,duration:2}, "-=1");
dual3.to(".dual-4-bar",{y:100,opacity:0, duration:2},);
dual3.from(".dual-4-blister",{y:100,opacity:0,duration:2});
dual3.to(".dual-4-ground",{y:220,duration:1,opactiy:0},);
dual3.to(".dual-4-blister",{opacity:0},);
dual3.from(".dual-4-fb",{opacity:0},);
dual3.to(".dual-4-fb",{opacity:0, duration:1},);
dual3.from(".dual-4-ca",{opacity:0, duration:1},);
dual3.to("#dual-sec-4",{opacity:0},);


const dual4 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-5",
    start:"top top",
    end:"+=3000",
  },
});

dual4.from("#dual-sec-5",{opacity:0,duration:2});
dual4.from(".dual-5",{opacity:0, duration:2});
dual4.from(".dual-5-ground",{y:100,duration:2}, "-=1");
dual4.to(".dual-5-bar",{y:100,opacity:0, duration:2},);
dual4.from(".dual-5-blister",{y:100,opacity:0,duration:2});
dual4.to(".dual-5-ground",{y:220,duration:1,opactiy:0},);
dual4.to(".dual-5-blister",{opacity:0},);
dual4.from(".dual-5-fb",{opacity:0},);
dual4.to(".dual-5-fb",{opacity:0, duration:1},);
dual4.from(".dual-5-ca",{opacity:0, duration:1},);
dual4.to(".dual-5-blister",{opacity:0},);
dual4.to("#dual-sec-5",{opacity:0},);

const dual5 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-6",
    start:"top top",
    end:"+=3000",
  },
});

dual5.from("#dual-sec-6",{opacity:0,duration:2});
dual5.from(".dual-6",{opacity:0, duration:2});
dual5.from(".dual-6-ground",{y:100,duration:2}, "-=1");
dual5.to(".dual-6-bar",{y:100,opacity:0, duration:2},);
dual5.from(".dual-6-blister",{y:100,opacity:0,duration:2});
dual5.to(".dual-6-ground",{y:220,duration:1,opactiy:0},);
dual5.to(".dual-6-blister",{opacity:0},);
dual5.from(".dual-6-fb",{opacity:0},);
dual5.to(".dual-6-fb",{opacity:0, duration:1},);
dual5.from(".dual-6-ca",{opacity:0, duration:1},);


const dual7 = gsap.timeline({
  scrollTrigger:{
    scrub:3,
    pin:true,
    ease:"none",
    trigger:"#dual-sec-7",
    start:"top top",
    end:"+=3000",
  },
});

dual7.from("#dual-sec-7",{opacity:0,duration:2});
dual7.from(".dual-7",{opacity:0, duration:2});
dual7.from(".dual-7-ground",{y:100,duration:2}, "-=1");
dual7.to(".dual-7-bar",{y:100,opacity:0, duration:2},);
dual7.from(".dual-7-blister",{y:100,opacity:0,duration:2});
dual7.to(".dual-7-ground",{y:220,duration:1,opactiy:0},);
dual7.to(".dual-7-blister",{opacity:0},);


});






const details = gsap.timeline({
  scrollTrigger:{
    scrub:2,
    trigger:".dual-battery",
    start:"top top",
    end:"+=500",
  },
});

details.from(".row",{opacity:0, y:200,stagger:0.5,duration:2}); 
